import { Box } from "@mui/joy";
import LinkV2 from "../common/LinkV2";
import { useChannelTalkContext } from "../../contexts/ChannelTalkContext";

export default function CxButton({
  type = "icon",
}: {
  type?: "icon" | "link";
}) {
  const { openChat } = useChannelTalkContext();

  return (
    <Box onClick={() => openChat()}>
      <LinkV2 text={"고객센터"} />
    </Box>
  );
}
